export const materialsData = [
    {
        type: "inconel",
        fullName: "Inconel 718 | UNS N07718 | 2.4668",
        formFactor:
            ['scrap', 'shavings'],
        compositions:
            {
                C: 0.08,
                Mn: 0.35,
                Si: 0.35,
                P: 0.015,
                S: 0.015,
                Cr: "17.0 - 21.0",
                Ni: "50.00 - 55.00",
                Mo: "2.80 - 3.30",
                Nb: "4.75 - 5.50",
                Ti: "0.65 - 1.15",
                Al: "0.20 - 0.80",
                Co: 1.00,
                Cu: 0.30,
                Fe: "BAL",
            },
    },
    {
        type: "inconel",
        fullName: "Inconel 713	| UNS N07713 | AMS 5377",
        formFactor:
            ['scrap', 'shavings'],
        compositions:
            {
                C: "0.08 - 0.20",
                Mn: "0.25",
                Si: "0.5",
                Al: "5.50 - 6.50",
                Cb: "1.80 - 2.80",
                Cr: "12.0 - 14.0",
                Ni: "BAL",
                Mo: "3.80 - 5.20",
                Cu: 0.5,
                Ti: "0.5 - 1.0",
            },
    },
    {
        type: "inconel",
        fullName: "Inconel 625 | UNS N06625 | 2.4856",
        formFactor:
            ['scrap', 'shavings'],
        compositions:
            {
                C: 0.10,
                Mn: 0.50,
                Si: 0.50,
                P: 0.015,
                S: 0.015,
                Cr: "20.00 - 23.00",
                Ni: 58.00,
                Mo: "8.00 - 10.00",
                Nb: "3.15 - 4.15",
                Fe: 5.00,
                Al: 0.40,
                Ti: 0.40,
                Co: 1.00,
                Cu: 0.5,
                Ta: 0.05,
            },
    },
    {
        type: "aisi",
        fullName: "AISI M2 | HS6-5-2C | 1.3343",
        formFactor:
            ['hardened_ingot'],
        compositions:
            {
                C: "0.86 - 0.94",
                Mn: 0.40,
                Mo: 5.00,
                V: 1.95,
                Si: 0.30,
                Cr: 4.15,
                W: "6.0 - 6.7",
                P: 0.03,
            },
    },
    {
        type: "aisi",
        fullName: "AISI 304L | UNS S30403 | X2CrNi18-9 | 1.4307",
        formFactor:
            ["scrap", "hardened_ingot", "ingot"],
        compositions:
            {
                C: 0.03,
                Mn: 2.00,
                P: 0.045,
                S: 0.015,
                Si: 0.75,
                Cr: "17.50 - 19.50",
                Ni: "8.00 - 10.00",
                Fe: "BAL",
            },
    },
    {
        type: "aisi",
        fullName: "AISI 316L | UNS S31603 | X2CrNiMo17-12-2 | 1.4404",
        formFactor:
            ["scrap", "hardened_ingot", "ingot"],
        compositions:
            {
                C: 0.03,
                Mn: 2.00,
                P: 0.040,
                S: 0.03,
                Si: 0.75,
                Cr: "16.00 - 18.00",
                Ni: "10.00 - 12.00",
                Mo: "2.00 - 2.50",
            },
    },
    {
        type: "aisi",
        fullName: "AISI 321 | UNS S32100 | X6CrNiTi18-10 | 1.4541",
        formFactor:
            ["scrap", "hardened_ingot", "ingot"],
        compositions:
            {
                C: 0.08,
                Mn: 2.00,
                P: 0.04,
                S: 0.03,
                Si: "0.40 - 1.00",
                Cr: "17.00 - 19.00",
                Ni: "9.50 - 12.00",
                N: 0.50,
                Mo: 0.50,
                Ti: 0.70,
                Fe: "BAL",
            },
    },
    {
        type: "other",
        fullName: "Alloy Tipe 718 | CrNiMo10-20-1",
        formFactor:
            ["ingot"],
        compositions:
            {
                C: 0.20,
                Mn: 0.70,
                Si: 0.20,
                P: 0.020,
                S: 0.01,
                Cr: "9.00 - 16.00",
                Ni: "18.00 - 23.00",
                Mo: "0.90 - 1.90",
                Nb: 0.2,
                Ti: 0.05,
                Al: 0.1,
                Co: 0.5,
                Cu: 0.30,
                W: 1.00,
                V: 0.10,
                Fe: "BAL",
            },
    },
    {
        type: "titan",
        fullName: "Titanium Gr. 5 | UNS R56400 | Ti6Al4V | 3.7165",
        formFactor:
            ["scrap", "shavings"],
        compositions:
            {
                N: 0.05,
                C: 0.10,
                H: 0.01,
                Fe: 0.40,
                O: 0.20,
                Al: "5.50 - 7.75",
                V: "3.50 - 4.50",
                Ti: "BAL",
            },
    },
];
